import React from 'react';
import { __ } from '@wordpress/i18n';

// tools
import getNumberWithCurrency from '../../../../helpers/getNumberWithCurrency';
import formatDeadlineDate from '../../../../helpers/formatDeadlineDate';

// components
import ModalCreateProject from '../../../../components/ModalCreateProject';
import { klona } from 'klona';

const ProjectInfo = ({ data }) => {
    return(
        <div className="projectInfo">
            <div className="projectInfo__header">
                <span>{data.title}</span>
                <ModalCreateProject key={data.id} editProject={klona(data)}/>
            </div>
            <div className="projectInfo__meta">
                <div>
                    <span>{__('Company', 'soundbetween')}</span>
                    <span>{data.company}</span>
                </div>
                <div>
                    <span>{__('Director', 'soundbetween')}</span>
                    <span>{data.director}</span>
                </div>
                <div>
                    <span>{__('Deadline', 'soundbetween')}</span>
                    <span>{formatDeadlineDate(data.deadline)}</span>
                </div>
                <div>
                    <span>{__('Budget', 'soundbetween')}</span>
                    <span>{getNumberWithCurrency(data.budget)}</span>
                </div>
            </div>
        </div>
    )
}

export default ProjectInfo;